<template>
    <div class="cash-payment-form">
        <form @submit.prevent="submit($event)" id="cash-form" class="row m-0 p-0 mb-2">
            <div class="row m-0 p-0">
                <div class="col-md-8 px-0">
                    <select 
                        data-vv-as="cash-installments" 
                        :class="{'input': true, 'is-invalid': errors.has('cash-installments') }"
                        name="cash-installments" 
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        v-model="card.installments"
                        id="cash-installments"
                        placeholder="Parcelas"
                    >
                        <option value="0" disabled selected> Opções de parcelamento </option>
                        <option :value="item.number" v-for="item in installments" :key="item.number">
                            {{item.number}}x de R${{item.value}}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        @{{ errors.first('cash-installments') }}
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-6" @click="cancel" :disabled="loading">
                            <div class="btn btn-block btn-dark">Voltar</div>
                        </div>
                        <div class="col-6" @click="submit">
                            <div v-if="!loading" class="btn btn-block btn-success">Pagar</div>
                            <button v-else class="form-control btn-disabled d-flex justify-content-center align-items-center" type="button" disabled>
                                <div class="spinner-border text-dark" role="status"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="alert alert-warning mb-0"> <i class="fas fa-warning"></i> Após a criação do pedido, receba o valor do pagamento e realize a baixa da fatura pelo painel administrador. </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    props: {
        installments: {},
        card: {},
        loading: {},
    },
    methods: {
        cancel() {
            this.$emit('close')
        },
        
        async submit() {
            await this.$validator.validate()

            if (this.card.installments === 0) {
                this.$emit('error', "Você precisa escolher uma opção de parcelamento")
            } else {
                this.$emit('submit')
            }
        }
    }
})
</script>

<style scoped>
    .spinner-border {
        height: 1rem;
        width: 1rem;
    }
</style>
